// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.FieldsDrop {
  background-color: yellowgreen;
}
.ocDrag dropListContainer {
  background-color: red;
}


.startTupelLevel {
  border-left: 2px solid black !important;
  ;
}

.multiTupelLevel {
  border-top: 2px solid black !important;
  ;
}

.endTupelLevel {
  border-right: 2px solid black !important;
  ;
}


.oc-list {
  max-width: 100%;
  /*max-width: fit-content;*/
  border: solid 1px #ccc;
  min-height: 60px;
  display: flex;
  flex-direction: row;
  /*background: white;*/
  border-radius: 4px;
  overflow: hidden;
}

.oc-item {
  max-width: -moz-fit-content;
  max-width: fit-content;
  border-right: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: lightgrey;
  font-size: 14px;
  flex-grow: 1;
  flex-basis: 0;
}

.oc-item-content {
  margin: 20px 10px;
}
.scaleAddOneItem {
  /*transform: scale(1.3,1);
  background-color: blue;*/
}

.colorRed {
  /*background-color: #ccc;*/
  background-color: yellowgreen;
  color: yellowgreen;
  height: 100%;
  /*-webkit-box-shadow: -21px 0px 0px 22px yellowgreen;*/
}

.hoverme {
  display: none
}

  .hoverme:hover{
    display: flex;
    /*background-color: red;*/
  }
.showme:hover .hoverme {
  display: flex;
  flex-direction: row-reverse;
  position: absolute;
  transform: translateY(-100%);
  transition: transform 0.5s ease;
  border: solid 1px lightgrey;
  border-bottom: unset;
  /*background-color: red;*/
}

/*.hoverme::before {
  content: "\\f1f8";
  position: relative;
  width: 25px;
  height: 25px;
  left: 7%;
  top: -25px;
  margin-left: -100px;
  background: rgb(255,220,65);
}*/

/*.showme:hover .hoverme {
  transform: scale(2, 2);
  transform: translateY(0.5,0.5);
  transition: transform 0.5s ease;*/


`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/objectcreator.droparea.css"],"names":[],"mappings":";AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;;;AAGA;EACE,uCAAuC;;AAEzC;;AAEA;EACE,sCAAsC;;AAExC;;AAEA;EACE,wCAAwC;;AAE1C;;;AAGA;EACE,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;0BACwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE;AACF;;EAEE;IACE,aAAa;IACb,yBAAyB;EAC3B;AACF;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;;;;;;;;EASE;;AAEF;;;mCAGmC","sourcesContent":["\r\n.FieldsDrop {\r\n  background-color: yellowgreen;\r\n}\r\n.ocDrag dropListContainer {\r\n  background-color: red;\r\n}\r\n\r\n\r\n.startTupelLevel {\r\n  border-left: 2px solid black !important;\r\n  ;\r\n}\r\n\r\n.multiTupelLevel {\r\n  border-top: 2px solid black !important;\r\n  ;\r\n}\r\n\r\n.endTupelLevel {\r\n  border-right: 2px solid black !important;\r\n  ;\r\n}\r\n\r\n\r\n.oc-list {\r\n  max-width: 100%;\r\n  /*max-width: fit-content;*/\r\n  border: solid 1px #ccc;\r\n  min-height: 60px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  /*background: white;*/\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.oc-item {\r\n  max-width: fit-content;\r\n  border-right: solid 1px #ccc;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  box-sizing: border-box;\r\n  cursor: move;\r\n  background: lightgrey;\r\n  font-size: 14px;\r\n  flex-grow: 1;\r\n  flex-basis: 0;\r\n}\r\n\r\n.oc-item-content {\r\n  margin: 20px 10px;\r\n}\r\n.scaleAddOneItem {\r\n  /*transform: scale(1.3,1);\r\n  background-color: blue;*/\r\n}\r\n\r\n.colorRed {\r\n  /*background-color: #ccc;*/\r\n  background-color: yellowgreen;\r\n  color: yellowgreen;\r\n  height: 100%;\r\n  /*-webkit-box-shadow: -21px 0px 0px 22px yellowgreen;*/\r\n}\r\n\r\n.hoverme {\r\n  display: none\r\n}\r\n\r\n  .hoverme:hover{\r\n    display: flex;\r\n    /*background-color: red;*/\r\n  }\r\n.showme:hover .hoverme {\r\n  display: flex;\r\n  flex-direction: row-reverse;\r\n  position: absolute;\r\n  transform: translateY(-100%);\r\n  transition: transform 0.5s ease;\r\n  border: solid 1px lightgrey;\r\n  border-bottom: unset;\r\n  /*background-color: red;*/\r\n}\r\n\r\n/*.hoverme::before {\r\n  content: \"\\f1f8\";\r\n  position: relative;\r\n  width: 25px;\r\n  height: 25px;\r\n  left: 7%;\r\n  top: -25px;\r\n  margin-left: -100px;\r\n  background: rgb(255,220,65);\r\n}*/\r\n\r\n/*.showme:hover .hoverme {\r\n  transform: scale(2, 2);\r\n  transform: translateY(0.5,0.5);\r\n  transition: transform 0.5s ease;*/\r\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
